<template>
  <div class="contenedor">
    <b-card class="contenedor">
      <div slot="header">
        <strong>
          <center style="font-size:12pt;">Pictogramas SGA</center>
        </strong>
      </div>

      <div v-if="pictogramas_et.Homologacion.length <= 0">
        <h5>
          <center>ESTE PRODUCTO NO SE HA CLASIFICADO CON SGA</center>
        </h5>
      </div>

      <div v-else>
        <b-row >
          <b-col sm="12">
            <h5 style="text-align:center;"> Clasificación </h5>
            <b-row >
              <div
                v-for="(pictograma, index) in pictogramas_et.Clasificacion"
                :key="index"
                style="height:140px"
              >
                <b-col>
                  <b-card
                    :img-src="pictograma.direccion"
                    img-alt="Image"
                    tag="article"
                    style="display:block;margin:auto;max-width: 60px; margin-top:5px; height:60px;border: 1px solid #ccc;background:#FF8300;"
                    class="mb-4"
                  ></b-card>
                </b-col>
              </div>
            </b-row>

            <h5 style="text-align:center;"> Homologación </h5>
            <b-row >
              <div
                v-for="(pictograma, index) in pictogramas_et.Homologacion"
                :key="index"
                style="height:140px"
              >
                <b-col>
                  <b-card
                    :img-src="pictograma.direccion"
                    img-alt="Image"
                    tag="article"
                    style="display:block;margin:auto;max-width: 60px; margin-top:5px; height:60px;border: 1px solid #ccc;"
                    :class="pictograma.clase"
                    class="mb-4"
                    @click="cambiaEstado(pictograma)"
                  ></b-card>
                </b-col>
              </div>
            </b-row>
          </b-col>
        </b-row>
      </div>


    </b-card>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
export default {
  name: "Pictogramas-homologacion",
  created() {
    //this.getPictogramas();
  },
  computed: {
    ...mapState("sgacompleto_et", ["selectedSgaCompleto", "version", "idioma"]),
    ...mapState("etiquetas", ["VisualEmpresa"]),
    ...mapState("sga_et", ["idiomas", "versiones", "pictogramas_et"])
  },
  methods: {
    /* actualizarSgaCompleto() {
      this.getSgaCompleto();
    }, */
    ...mapActions("sgacompleto_et", ["getSgaCompleto"]),
    ...mapActions("sga_et", ["cambiaEstado"]),
    ...mapMutations("sgacompleto_et", ["cambiaIdioma", "cambiaVersion"])
  }
};
</script>

<style scoped>
.pictograma{
  background: #ccc;
  opacity: 0.4;
}
.seleccionado{
  background: #00FF83;
  opacity: 1;
}
</style>
